import React, {useEffect, useState} from "react";
import {
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment-timezone';
import { useLocation } from "react-router-dom";
import { WxHourly } from "./wxTables/WxHourly";
import { WxDaily } from "./wxTables/WxDaily";

type WxProps = {
    station: any,
    viewMode: any, 
    setViewMode: any,
}


export const WxTab: React.FC<WxProps> = ({ station, viewMode, setViewMode}) =>{
  const location = useLocation();
  const [startDate, setStartDate] = useState<Date | null>(
    moment().subtract(14, "days").toDate()
  );
  const [endDate, setEndDate] = useState<Date | null>(
    moment().add(7, "days").toDate()
  );
  const [errorStartDate, setErrorStartDate] = useState<string | null>(
    null
  );
  const [errorEndDate, setErrorEndDate] = useState<string | null>(null);

  useEffect(()=>{
    if(location?.state){
      const station:any = location.state
      if(station.defaultView==='daily'){
        setViewMode('daily')
      }
    }
    if(location?.pathname.includes('daily')){
      setViewMode('daily')
    }

  },[location?.state, location?.pathname, setViewMode]);
  
/*TO DO once integration happens, make call to populate filters */

  return (
    <Box>

      {/* Filters */}
      <Box className="filter" >
        {/* Radio Buttons */}
        <RadioGroup 
        sx={{ paddingLeft : "3%",}}
        row value={viewMode}
          onChange={(e) => setViewMode(e.target.value)}>
          <FormControlLabel value="daily" control={<Radio 
          sx={{
            marginRight: '5px',
            color: "#016601", 
            backgroundColor: "white",
            width: "20%", 
              height: "20%",
            "&.Mui-checked": {
              color: "#016601", 
              backgroundColor: "white",
            },            
          }}
          />} label="Daily" />
          <FormControlLabel value="hourly" control={<Radio 
          sx={{
            marginRight: '5px',
            color: "#016601", 
            backgroundColor: "white",
            width: "20%", 
              height: "20%",
            "&.Mui-checked": {
              color: "#016601", 
            },
          }}
          />} label="Hourly" />
        </RadioGroup>

        {/* Date Range */}
        <Box>
          <div>
            <span className="font-sans-md text-bold">Date Range</span>{" "}
            <div
              className={`date-range-picker-wrapper`}
              style={{ margin: "10px 0" }}
            >
              <DatePicker
                label="Start Date"
                value={startDate}
                onChange={(newValue) => {
                  if (newValue) {
                    setStartDate(newValue);
                    if (endDate && newValue > endDate) {
                      setErrorStartDate("Start Date cannot be after End Date");
                    } else {
                      setErrorStartDate(null);
                    }
                  } else {
                    setErrorStartDate("Start Date is required");
                  }
                }}
                slotProps={{
                  textField: {
                    error: !!errorStartDate,
                    helperText: errorStartDate,
                    id: "uploadStartDate",
                    sx: {
                      backgroundColor: "white", 
                      borderRadius:"8%"
                    },
                  },
                }}
              />
              <span style={{ margin: "0 10px" }}></span>
              <DatePicker
                label="End Date"
                value={endDate}
                onChange={(newValue) => {
                  if (newValue) {
                    setEndDate(newValue);
                    if (startDate && newValue < startDate) {
                      setErrorEndDate("End Date cannot be before Start Date");
                    } else {
                      setErrorEndDate(null);
                    }
                  } else {
                    setErrorEndDate("End Date is required");
                  }
                }}
                slotProps={{
                  textField: {
                    error: !!errorEndDate,
                    helperText: errorEndDate,
                    id: "uploadEndDate",
                    sx: {
                      backgroundColor: "white", 
                      borderRadius:"8%"
                    },
                  },
                }}
              />
            </div>
          </div>
        </Box>
      </Box>

      {/* Table for Hourly */}
      {viewMode === "hourly" && (
        <WxHourly station={station} startDate={startDate} endDate={endDate}/>
      )}

      {/* Table for Daily */}
      {viewMode === "daily" && (
        <WxDaily station={station} startDate={startDate} endDate={endDate}/>
      )}
    </Box>
  );
}
